var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{class:{
        header: _setup.isHeader(),
        unindented: !_vm.recipeIngredientsHaveSubgroups,
    },on:{"click":_setup.toggleDone}},[_c('div',{staticClass:"ingredient"},[_c('VueShowdown',{attrs:{"markdown":_setup.formattedIngredient,"flavor":"github"}})],1),_vm._v(" "),(!_vm.ingredientHasCorrectSyntax)?_c('span',{staticClass:"icon-error"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }